import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolTypeSetup } from "../shared/data.service";
import { SchoolTypeRequest } from "../shared/SchoolTypeRequest";
import { StringRequest } from "../shared/StringRequest";

@Component({
	selector: "app-district-add-school-type",
	templateUrl: "./district-add-school-type.component.html",
	styleUrls: ["./district-add-school-type.component.css"],
})
export class DistrictAddSchoolTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolTypeSetupService: DataService_SchoolTypeSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		this.DefinedBy = this.user.UserLevelID == 3 ? "School User" : "District User"; //Should only be District User
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	user: any;

	//Form
	SchoolTypeCD: any = "";
	SchoolTypeDesc: any = "";
	DefinedBy: any = "User";

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onAdd() {
		if (this.SchoolTypeCD == "") {
			this.errorMessage = "Enter a code";
			return;
		} else if (this.SchoolTypeDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		} else {
			this.CheckCD();
		}
	}

	CheckCD() {
		let parms: StringRequest = {
			str: this.SchoolTypeCD,
		};

		var result = this.SchoolTypeSetupService.SchoolTypeCDUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "School Type Code/Abbreviation Already in Use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.SchoolTypeDesc,
		};

		var result = this.SchoolTypeSetupService.SchoolTypeDescUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "School Type Name/Description Already in Use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DFB = this.user.UserLevelID == 3 ? 3 : 4;

		let parms: SchoolTypeRequest = {
			SchoolTypeID: -1,
			SchoolTypeCD: this.SchoolTypeCD,
			SchoolTypeDesc: this.SchoolTypeDesc,
		};

		var result = this.SchoolTypeSetupService.SchoolTypeInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Type was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the School Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
